<script>
import Button from '@/components/reusable/Button.vue';
import ProfileContainer from "@/components/ProfileContainer.vue";
import HomeProjectsGrid from "@/components/projects/HomeProjectsGrid.vue";

export default {
  name: 'Home',
  components: {
    HomeProjectsGrid,
    ProfileContainer,
    Button,
  },
  computed: {
    age() {
      const birthDate = new Date('2001-03-12');
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }
  }
};
</script>

<template>
  <div class="container mx-auto text-secondary-dark dark:text-ternary-light">
    <ProfileContainer
        heading="Full Stack Developer"
        :text="[
      `Als ${age}-jarige Full Stack Developer combineer ik moderne technologieën met doelgerichte oplossingen. Mijn expertise ligt in het ontwikkelen van schaalbare applicaties met focus op gebruiksvriendelijkheid en prestaties.`,
      'Met een hands-on mentaliteit en oog voor detail werk ik aan diverse projecten die technische uitdagingen omzetten in effectieve oplossingen. Ontdek in mijn portfolio een selectie van mijn meest impactvolle projecten.',
    ]"
    />


    <!-- Other Content -->
    <div class="mt-10 sm:mt-16">
      <!-- Projects -->
      <HomeProjectsGrid/>

      <!-- Load More Projects Button -->
      <div class="mt-10 sm:mt-20 flex justify-center">
        <router-link
            to="/projects"
            class="font-general-medium flex items-center px-6 py-3 rounded-lg shadow-lg hover:shadow-xl bg-indigo-500 hover:bg-indigo-600 focus:ring-1 focus:ring-indigo-900 text-white text-lg sm:text-xl duration-300"
            aria-label="More Projects"
        >
          <Button title="More Projects"/>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
